import { Promise } from 'rsvp';
import Service, { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';

/**
 * Service for Payment related API calls.
 */
export default Service.extend({
  api: service(),
  store: service(),
  errorTracker: service('error-tracker'),

  /**
   * Make a payment pdf invoice for a payment id
   *
   * @param {String} paymentId
   * @return {Ember.RSVP.Promise}
   */
  makePaymentInvoice(paymentId) {
    return new Promise((resolve, reject) => {
      this.get('_makePaymentInvoiceTask').perform(paymentId, resolve, reject);
    });
  },

  /**
   * Task to make a payment pdf invoice for a user.
   *
   * @param {String} paymentId
   * @param {Function} resolve
   * @param {Function} reject
   * @private
   */
  _makePaymentInvoiceTask: task(function *(paymentId, resolve, reject) {
    let payment = this.get('store').peekRecord('shPayment', paymentId);
    if (!payment) {
      payment = yield this.get('store').findRecord('shPayment', paymentId);
    }

    if (!payment) {
      this.get('errorTracker').error('_makePaymentInvoiceTask -- Could not load payment id ' + paymentId);
      reject(false);
      return;
    }

    payment.makePDF()
      .then(() => resolve(true))
      .catch(e => {
        this.get('errorTracker').error('_makePaymentInvoiceTask -- Could not make pdf for paymentId ' + paymentId);
        reject(e);
      });
  }).drop(),
});
